import { createContext, useContext, useState } from 'react';

const ThemeContext = createContext();

// Bumped from the legacy `sn-theme` key: theme was auto-saved on every load
// (not just on an explicit toggle), so almost every existing visitor already
// has a stale `dark` value stored — a fresh key resets everyone to the new
// light default once, while still persisting any explicit toggle going forward.
const THEME_KEY = 'sn-theme-v2';

// Get saved theme or default to light
const getSavedTheme = () => localStorage.getItem(THEME_KEY) || 'light';

// Apply theme class to HTML element immediately
const applyTheme = (theme) => {
  if (theme === 'dark') {
    document.documentElement.classList.add('dark');
  } else {
    document.documentElement.classList.remove('dark');
  }
  localStorage.setItem(THEME_KEY, theme);
};

// Apply on initial load (before React renders)
applyTheme(getSavedTheme());

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(getSavedTheme);

  const toggleTheme = () => {
    const next = theme === 'dark' ? 'light' : 'dark';
    applyTheme(next);
    setTheme(next);
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
